import { UPDATE_STEP, SET_MENU_MODAL, SHOW_MODAL, CLOSE_MODAL } from './actions';

const initialState = {
  step: 0,
  showCreateMenuModal: false,
  showDuplicateMenuModal: false,
  showEditMenuModal: false,
  showDisabledMenuModal: false,
  showPublishMenuModal: false,
  showDeleteMenuModal: false,
  showEditConfirmationMenuModal: false,
  menu: {},
  menuDelete: {},
  publishMenu: {},
};

export default function menuModal(state = initialState, action) {
  switch (action.type) {
    case UPDATE_STEP:
      return {
        ...state,
        step: action.step,
      };
    case SET_MENU_MODAL:
      return {
        ...state,
        [action.name]: action.menu,
      };
    case SHOW_MODAL:
      return {
        ...state,
        ...action.payload,
      };
    case CLOSE_MODAL:
      return { ...initialState };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/menuModal/reducer.js